import { motion } from 'motion/react';

import { iconsSources } from '../../helpers/icons';
import { hideNumber } from '../../helpers/titreHelper';

import styles from './Message.module.css';

import hum from '../../assets/images/hum.webp';

const Message = ({
  message,
  authorFontSize,
  winId,
  isWinner,
  currentId,
  user,
}) => {
  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel] || hum;
  };

  const avatar = message?.image?.includes(`${user}_${message.channel}`)
    ? iconsSources[message?.channel]
    : (message?.image !== '1' && message?.image) ||
      iconsSources[message?.channel] ||
      hum;

  return (
    <div className={styles.wrapper}>
      {message && (
        <motion.div
          animate={{
            opacity: isWinner && winId !== currentId ? 0 : 1,
            scale: !isWinner ? 1 : winId !== currentId ? 1 : 1.4,
          }}
          transition={{
            opacity: { duration: 0.5, delay: 0.4 },
            scale: { duration: 0.5, delay: 0.4 + 0.68 },
          }}
          className={styles.blockMsg}
        >
          <motion.div
            animate={{
              borderColor: !isWinner
                ? '#ffffff'
                : winId !== currentId
                ? '#ffffff'
                : ['#ffffff', '#0252A9', '#FE37C5', '#ffffff', '#FE37C5'],
            }}
            transition={{ duration: 0.68, delay: 0.4 }}
            className={styles.avatar}
          >
            <div
              className={styles.avatarBg}
              style={{
                background: `url(${
                  iconsSources[message?.channel]
                }) center/cover no-repeat `,
              }}
            />
            <img src={avatar} alt={message?.author} onError={errorHandler} />
          </motion.div>
          <motion.div
            animate={{
              color: !isWinner
                ? '#00233a'
                : winId !== currentId
                ? '#00233a'
                : ['#00233a', '#ffffff', '#00233a', '#ffffff'],

              backgroundColor: !isWinner
                ? '#ffffff'
                : winId !== currentId
                ? '#ffffff'
                : ['#ffffff', '#FE37C5', '#ffffff', '#FE37C5'],
            }}
            transition={{ duration: 0.68, delay: 0.4 }}
            className={styles.nameAuthor}
            style={{ fontSize: `${authorFontSize}rem` }}
          >
            <div>{message?.author || hideNumber(message?.senderNumber)}</div>
          </motion.div>
        </motion.div>
      )}
    </div>
  );
};

export default Message;
